import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";

export default function NotFoundPage() {
  return (
    <div
      data-testid="not-found-page"
      className="flex min-h-screen flex-col items-center justify-center bg-[#F7F7F5] px-6 text-center"
    >
      <Link
        to="/"
        className="mb-10 inline-flex items-center gap-2.5"
        aria-label="Idea AI home"
      >
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-zinc-900 to-black">
          <Sparkles className="h-4 w-4 text-white" strokeWidth={2.4} />
        </span>
        <span className="text-[16px] font-extrabold tracking-tight text-zinc-900">
          Idea AI
        </span>
      </Link>

      <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-zinc-500">
        404 · Off-route
      </div>
      <h1 className="mt-3 text-[64px] font-black leading-[0.95] tracking-tight text-zinc-900 md:text-[96px]">
        Page not found.
      </h1>
      <p className="mt-4 max-w-md text-[14px] leading-relaxed text-zinc-500 md:text-[16px]">
        That route doesn't exist in your boardroom. Let's get you back on track.
      </p>

      <Link
        to="/"
        data-testid="not-found-home-link"
        className="group mt-8 inline-flex h-12 items-center gap-2 rounded-full bg-black px-6 text-[14px] font-semibold text-white transition-all hover:-translate-y-0.5 hover:bg-zinc-800 hover:shadow-[0_18px_36px_-18px_rgba(0,0,0,0.55)]"
      >
        Take me home
        <ArrowRight
          className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
          strokeWidth={2.4}
        />
      </Link>
    </div>
  );
}
